<template>
  <div class="min-h-screen flex flex-col">
    <BlackFridayBanner />

    <div class="flex-1 flex items-center justify-center p-4">
      <div class="max-w-xl w-full">
        <BackButton @click="$emit('previous')" />

        <div class="bg-white rounded-2xl shadow-xl p-6">
          <QuizProgress :current-step="3" />

          <AgeHeader :first-name="firstName" />

          <div class="relative flex flex-col items-center mb-8">
            <AgeAvatar
              :image="currentImage"
              :age="age"
            />

            <div class="content relative overflow-visible rounded-2xl bg-white shadow-lg w-full">
              <DateSelector
                v-model:day="day"
                v-model:month="month"
                v-model:year="year"
                :month-names="monthNames"
                :years="years"
              />

              <AgeDisplay
                v-if="age"
                :age="age"
                class="mt-4"
              />

              <button
                @click="submitAge"
                :disabled="!isValidDate"
                class="w-full mt-4 py-4 px-6 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed rounded-t-none"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <LegalFooter />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import BlackFridayBanner from '../../../BlackFridayBanner.vue'
import LegalFooter from '../../../LegalFooter.vue'
import BackButton from '../../../common/BackButton.vue'
import QuizProgress from '../../QuizProgress.vue'
import AgeHeader from './components/AgeHeader.vue'
import AgeAvatar from './components/AgeAvatar.vue'
import DateSelector from './components/DateSelector.vue'
import AgeDisplay from './components/AgeDisplay.vue'
import { useAgeCalculation } from './composables/useAgeCalculation'
import { useAgeImage } from './composables/useAgeImage'

const props = defineProps<{
  gender: 'male' | 'female'
  firstName: string
}>()

const emit = defineEmits(['age-selected', 'previous'])

const {
  day,
  month,
  year,
  monthNames,
  years,
  age,
  isValidDate,
  initializeDate,
  formatDate
} = useAgeCalculation()

const { currentImage } = useAgeImage(props.gender, age)

onMounted(() => {
  initializeDate()
})

const submitAge = () => {
  if (isValidDate.value && age.value) {
    const formattedDate = formatDate()
    // Store age and birth date in localStorage for checkout tracking
    localStorage.setItem('quiz_age', age.value.toString())
    localStorage.setItem('quiz_birthdate', formattedDate)
    emit('age-selected', age.value, formattedDate)
  }
}
</script>

<style scoped>
.content {
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

img {
  width: 128px;
  height: 128px;
}
</style>